import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
setTimeout(() => {
  root.render(
    <React.StrictMode>
      <ToastContainer position="top-right" />
      <App />
    </React.StrictMode>
  );
}, 10);


reportWebVitals();
